import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import { selectBorderColor } from "../../../../../../redux/slices/enviromentSlice/EnviromentSlice.selectors";

import DropdownContainer from "../../../../../../components/dropdownContainer/DropdownContainer";
import colors from "../../../../../../styles/variables.module.scss";

const FilterComponent = (props: {
  children: React.ReactNode;
  name: string;
  styles: any;
  shouldExpand?: boolean;
}) => {
  const { children, name, styles, shouldExpand } = props;
  const [showDropdown, setShowDropdown] = useState(false);

  const borderColor = useAppSelector(selectBorderColor);
  const { t } = useTranslation();

  return (
    <div
      className={styles.filterDropdown}
      onClick={(e) => {
        // e.stopPropagation();
        setShowDropdown(!showDropdown);
      }}
      style={{ borderColor: borderColor || colors.borderLightgray }}
    >
      <div className={styles.filterDropdown_selected}>{t(`${name}`)}</div>
      <div
        className={`${styles.filterDropdown_iconContainer} ${
          showDropdown && styles.dropdownIconOpen
        }`}
      >
        <img
          src="https://booking.availroom.com/v2/assets/icons/dropdown.svg"
          alt=""
        />
      </div>
      {showDropdown && (
        <DropdownContainer
          className={shouldExpand && styles.expand}
          onClickOutside={() => setShowDropdown(false)}
        >
          <div className={styles.dropdownSpacing}>
            <div className={styles.mainContainer}>{children}</div>
          </div>
        </DropdownContainer>
      )}
    </div>
  );
};

export default FilterComponent;
